<template>
  <div class="flex flex-1 flex-col">
    <!--        <div>-->
    <!--            <div class="flex flex-1 flex-col">-->
    <!--                <div class="text-sm font-medium text-gray-900">-->
    <!--                    {{ entry.parent.name }}-->
    <!--                </div>-->
    <!--                <div class="text-xs text-gray-600">-->
    <!--                    {{ entry.parent.batch_num }} | {{ entry.parent.tag_num }}-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="mt-2 flex flex-1 items-center justify-start text-sm">
      <div class="pr-4">
        {{ entry.amount }}
      </div>
      <div class="flex flex-1 flex-col">
        <div class="text-sm font-medium text-gray-900">
          <Link :href="route('packages.show', { package: entry.parent.id })">{{ entry.parent.sub_lot_num }}</Link>
        </div>
        <div class="text-xs text-gray-600">{{ entry.parent.details.name }} || {{ entry.parent.details.tag_num }}</div>
        <div class="text-xs text-gray-600">{{ entry.parent.space_name }} | {{ entry.parent.location_name }}</div>
        <div
          v-if="entry.display_type"
          class="text-xs text-gray-600"
        >
          ({{ entry.display_type }})
        </div>
      </div>
      <div class="flex ml-6">
        <button
          @click="deleteEntry()"
          :disabled="deleting"
          type="button"
          class="font-medium text-indigo-600 hover:text-indigo-500"
        >
          <span v-if="!deleting">Remove</span>
          <span v-if="deleting">Removing...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  props: {
    /**
     * A balance entry tied to an order item as causer and package as parent.
     */
    entry: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        amount: -1 * this.entry.amount
      }),
      updating: false,
      deleting: false
    }
  },

  components: {
    Link
  },

  methods: {
    /**
     * Updates an entry
     */
    updateEntry() {
      if (this.updating) {
        return
      }

      this.updating = true

      this.form
        .transform((data) => {
          return {
            amount: -1 * data.amount
          }
        })
        .put(route('balance-entries.update', { balance_entry: this.entry.id }), {
          onSuccess: (response) => {
            this.$emit('updated', this.entry)
          },
          onError: (response) => {
            //
          },
          onFinish: (response) => {
            this.updating = false
          }
        })
    },
    /**
     * Removes a package balance entry from order item.
     */
    deleteEntry() {
      if (this.deleting) {
        return
      }

      this.deleting = true

      this.form.delete(route('balance-entries.destroy', { balance_entry: this.entry.id }), {
        onSuccess: (response) => {
          this.$emit('deleted', this.entry)
        },
        onError: (response) => {
          //
        },
        onFinish: (response) => {
          this.deleting = false
        }
      })
    }
  }
}
</script>
